import axios from 'axios'
import { inShopifyProductPage, inAdminWidgetPage, inTestPage, inBta, inShopifyCartPage } from '../utilities'
import UpcomingEvent from './upcoming-event'
import ProductWidget from './product-widget'
import CartToReservation from './bta-convert-cart-to-reservation'
import './index.css'

export class BtaWidgetLoader {
  static render(options) {
    this.options = options || {}

    const afterGotToken = () => {
      if (this.checkEnable('activity') && options.externalId && (inShopifyProductPage() || inAdminWidgetPage() || inTestPage())) {
        new ProductWidget(options).render()
      }
    }

    axios.all([this.getCartToken()]).then(() => afterGotToken())

    if (this.checkEnable('upcoming_event') && (!inBta() || inAdminWidgetPage() || inTestPage())) {
      new UpcomingEvent(options).render()
    }

    if (this.checkEnable('cart_check') && (inShopifyCartPage() || inAdminWidgetPage() || inTestPage())) {
      new CartToReservation(window.BtaSdk, window.BtaConfig);
    }
  }

  static cartToReservation(){
    // temporary for slide cart_check
    return (document.querySelector('#booking-status') && new CartToReservation(window.BtaSdk, window.BtaConfig))
  }

  static getCartToken() {
    const self = this

    return axios.get('/cart/update.js')
                .then(({data: {token}}) => self.options.cartToken = token)
                .catch(() => self.options.cartToken = '')
  }

  static checkEnable(name) {
    return this.options.shopConfig && this.options.shopConfig.widget_enabled_list && this.options.shopConfig.widget_enabled_list.includes(name)
  }
}
